import {
  type KeyboardShortcutActions,
  useKeyboardShortcuts,
} from 'hooks/use-keyboard-shortcuts'

export type UndoRedoShortcutParams = {
  canUndo: boolean
  canRedo: boolean
  undo: () => void
  redo: () => void
  enabled?: boolean
}

/**
 * Cmd/Ctrl+Z → undo, Shift+Cmd/Ctrl+Z (and Ctrl+Y) → redo.
 *
 * The matcher requires exact modifier equality, so each modifier combination is
 * registered separately (same as `GLOBAL_SHORTCUT_KEYS`' cmd+K / ctrl+K).
 * `respectInputs` leaves native text-field undo alone while typing.
 */
export const useUndoRedoShortcuts = ({
  canUndo,
  canRedo,
  undo,
  redo,
  enabled = true,
}: UndoRedoShortcutParams): KeyboardShortcutActions => {
  const onUndo = (): void => {
    if (canUndo) undo()
  }
  const onRedo = (): void => {
    if (canRedo) redo()
  }
  return useKeyboardShortcuts(
    {
      'meta+z': onUndo,
      'ctrl+z': onUndo,
      'meta+shift+z': onRedo,
      'ctrl+shift+z': onRedo,
      'ctrl+y': onRedo,
    },
    { respectInputs: true, enabled },
  )
}
